import React from 'react';
import BooksList from '../components/BooksList';

const Books = () => (
  <>
    <BooksList />
  </>
);

export default Books;
